<template>
  <form v-on:submit.prevent="saveForm" novalidate>

    <LoaderContent v-if="isLoading" :welcomeMessage="false"  />

    <div class="form-row">
      <div class="form-group col-12 col-md-6" :class="{ 'is-invalid': $v.country.$error, 'col-md-12': country != '31' }">
        <label :for="'education-input-country'+_uid"><span v-if="">*</span> País</label>
        <selectize :id="'education-input-country'+_uid" :settings="countrySettings" v-model="country">
          <option :value="country.id" v-for="(country, index) in $store.state.domains.countries" :key="index">{{ country.name }}</option>
        </selectize>
      </div>

      <div class="form-group col-12 col-md-6" :class="{ 'is-invalid': $v.state.$error }" v-if="country == '31'">
        <label :for="'education-input-state'+_uid"><span v-if="">*</span> Estado</label>
        <selectize :id="'education-input-state'+_uid" :settings="stateSettings" v-model="state">
          <option :value="state.id" v-for="(state, index) in $store.state.domains.states" :key="index">{{ state.name }}</option>
        </selectize>
      </div>

      <div class="form-group col-12 col-md-4" :class="{ 'col-md-12': level == 'elementary_school', 'is-invalid': $v.level.$error }">
        <label :for="'education-input-level'+_uid"><span v-if="">*</span> Nível</label>
        <selectize :id="'education-input-level'+_uid" :settings="levelSettings" v-model="level">
          <option :value="level.id" v-for="(level, index) in $store.state.domains.education_levels" :key="index">{{ level.description }}</option>
        </selectize>
      </div>

      <div class="form-group col-12 col-md-4" v-if="level != 'elementary_school'" :class="{ 'col-md-8': level == 'elementary_school' || level == 'high_school', 'is-invalid': $v.institution.$error }">
        <label :for="'education-input-institution'+_uid"><span v-if="level != 'elementary_school' && level != 'high_school'">*</span> Instituição</label>
        <selectize :id="'education-input-institution'+_uid" :settings="institutionSettings" v-model="institution">
          <option :value="institution.id" v-for="(institution, index) in institutions" :key="index">{{ institution.name }}</option>
        </selectize>
      </div>

      <div class="form-group col-12 col-md-4" v-if="level != 'elementary_school' && level != 'high_school'" :class="{ 'is-invalid': $v.course.$error }">
        <label :for="'education-input-course'+_uid"><span v-if="">*</span> Curso</label>
        <selectize :id="'education-input-course'+_uid" :settings="courseSettings" v-model="course">
          <option :value="course.id" v-for="(course, index) in courses" :key="index">{{ course.name }}</option>
        </selectize>
      </div>

      <div class="form-group col-12 col-md-6" :class="{ 'col-md-12': status != 'studying', 'is-invalid': $v.status.$error }">
        <label :for="'education-input-status'+_uid"><span v-if="">*</span> Status</label>
        <selectize :id="'education-input-status'+_uid" :settings="statusSettings" v-model="status">
          <option :value="status.id" v-for="(status, index) in $store.state.domains.education_status" :key="index">{{ status.description }}</option>
        </selectize>
      </div>

      <div class="form-group col-12 col-md-6" v-if="status == 'studying'">
        <label :for="'education-input-campus'+_uid">Campus</label>
        <input type="text" class="form-control" :id="'education-input-campus'+_uid" v-model="campus">
      </div>

      <div class="form-group col-12 col-md-4" :class="{ 'col-md-6': status != 'studying' }">
        <label :for="'education-input-date-from'+_uid">Início</label>
        <the-mask type="tel" :id="'education-input-date-from'+_uid" class="form-control" v-model="start_date" :mask="'##/####'" :masked="true" placeholder="Exemplo: 01/2010" />
      </div>

      <div class="form-group col-12 col-md-4" :class="{ 'col-md-6': status != 'studying', 'is-invalid': $v.end_date.$error }">
        <label :for="'education-input-date-to'+_uid"><span v-if="status != 'interrupted'">*</span> Previsão/Data de Conclusão</label>
        <the-mask type="tel" :id="'education-input-date-to'+_uid" class="form-control" v-model="end_date" :mask="'##/####'" :masked="true" placeholder="Exemplo: 06/2012" />
        <small v-if="end_date.length > 2 && !$v.end_date.isAfterStart">Deve ser posterior a data inicial</small>
      </div>

      <div class="form-group col-12 col-md-4" v-if="status == 'studying'" :class="{ 'is-invalid': $v.period.$error }">
        <label :for="'education-input-period'+_uid"><span v-if="">*</span>Turno</label>
        <selectize :id="'education-input-period'+_uid" :settings="periodSettings" v-model="period">
          <option :value="period.id" v-for="(period, index) in $store.state.domains.education_periods" :key="index">{{ period.description }}</option>
        </selectize>
      </div>
    </div>

    <p class="small text-right font-italic">Campos com * são obrigatórios.</p>

    <div class="d-flex align-items-center mt-4" v-if="hasButtons">
      <button type="reset" class="btn btn-light mr-auto" @click="reset()">Cancelar</button>
      <button type="submit" class="btn btn-blue-ml" style="border-radius: 30px; border-top-left-radius: 0;">Salvar</button>
    </div>

  </form>
</template>

<script>
  import LoaderContent from '@/components/loader/LoaderContent.vue'
  import { validationMixin } from 'vuelidate'
  import { required, requiredIf, minValue } from 'vuelidate/lib/validators'

  export default {
    name: 'FormEducation',

    data() {
      return {
        education_id: '',
        country: '31',
        state: '',
        level: '',
        institution: '',
        course: '',
        status: '',
        campus: '',
        start_date: '',
        end_date: '',
        period: '',
        countrySettings: {
          create: false,
          createOnBlur: false,
          dropdownParent: 'body'
        },
        stateSettings: {
          create: false,
          createOnBlur: false,
          dropdownParent: 'body',
          onChange: (value) => {
            this.state = value;
            this.$store.dispatch("graphql_queries/query", `
              domains(state: "${ this.$store.state.domains.states.find( st => st.id == value )['abbr'] }") {
                institutions {id, name, state}
              }
            `).then((data) => {
              this.institution = '';
              this.institutions = this.$store.state.domains.institutions;
            });
          }
        },
        levelSettings: {
          create: false,
          createOnBlur: false,
          dropdownParent: 'body',
          onChange: (value) => {
            this.level = value;
            if(this.level != 'elementary_school' && this.level != 'high_school'){
              this.$store.dispatch("graphql_queries/query", `
                domains(level: "${value}") {
                  courses{id, name, level},
                }
              `).then((data) => {
                this.course = '',
                this.courses = this.$store.state.domains.courses;
              });
            }
          }
        },
        institutions: this.$store.state.domains.institutions,
        institutionSettings: {
          create: true,
          createOnBlur: true,
          dropdownParent: 'body',
          onItemAdd: (value, data) => {
            this.institution = value
          }
        },
        courses: this.$store.state.domains.courses,
        courseSettings: {
          create: true,
          createOnBlur: true,
          dropdownParent: 'body',
          onItemAdd: (value, data) => {
            this.course = value
          }
        },
        statusSettings: {
          create: false,
          createOnBlur: false,
          dropdownParent: 'body',
          onChange: (value) => {
            this.status = value;
            if(this.$store.state.domains.education_periods.length == 0){
              this.$store.dispatch("graphql_queries/query", `
                domains{
                  educationPeriods {id, description},
                }
              `)
            }
          }
        },
        periodSettings: {
          create: false,
          createOnBlur: false,
          dropdownParent: 'body'
        },
        isLoading: false,
        source: 'chatbot'
      }
    },

    props: {
      hasButtons: {
        type: Boolean,
        default: false
      },
      
      storeByEventBus: {
        type: Boolean,
        default: false
      },

      rawData: {
        default: () => {}
      }
    },
    
    components: {
      LoaderContent
    },
    
    watch: {
      country: function (newValue, oldValue) {
        if(newValue != oldValue){
          this.state = ''
        }
      },
    },
    
    mixins: [validationMixin],
    
    validations: {
      country: { required },
      
      state: { required: requiredIf(function (value) {
        return this.country == '31'
      }) },
      
      level: { required },
      
      institution: { required: requiredIf(function (value) {
        return this.level != 'elementary_school' && this.level != 'high_school'
      }) },
      
      course: { required: requiredIf(function (value) {
        return this.level != 'elementary_school' && this.level != 'high_school'
      }) },
      
      status: { required },

      start_date: { 
        isDate: (value, _this) => {
          if(value.length > 1){
            return value.length == 7 && _this.$moment(`${value.split('/').reverse().join('-')}-01`).isValid();
          }else{
            return true;
          }
        }
      },

      end_date: {
        required: requiredIf(function (value) {
          return this.status != 'interrupted' && this.level != 'elementary_school' && this.level != 'high_school'
        }),

        isDate: (value, _this) => {
          if(_this.status == 'interrupted' && value.length > 1){
            return value.length == 7 && _this.$moment(`${value.split('/').reverse().join('-')}-01`).isValid();
          }else if(_this.status == 'interrupted' && value.length == 0){
            return true;
          }else if(_this.status != 'interrupted'){
            return value.length == 7 && _this.$moment(`${value.split('/').reverse().join('-')}-01`).isValid();
          }else{
            return true;
          }
        },
        
        isAfterStart: (value, _this) => {
          if(_this.start_date.length == 0){
            return true;
          }else{
            if(_this.status == 'interrupted' && value.length > 1){
              return value.length == 7 && _this.$moment(`${value.split('/').reverse().join('-')}-01`).isAfter(`${_this.start_date.split('/').reverse().join('-')}-01`)
            }else if(_this.status == 'interrupted' && value.length == 0){
              return true;
            }else if(_this.status != 'interrupted'){
              return value.length == 7 && _this.$moment(`${value.split('/').reverse().join('-')}-01`).isAfter(`${_this.start_date.split('/').reverse().join('-')}-01`)
            }else{
              return true;
            }
          }
        }
      },

      period: { required: requiredIf(function (value) {
        return this.status == 'studying'
      }) },
    },
    
    mounted() {
      this.initListeners();
      this.setRawData();
    },
    
    destroyed() {
      this.$EventBus.$off('editingEducation')
    },
    
    beforeDestroy(){
      this.$store.commit('EDUCATIONS_FORMS', {_uid: this._uid});
    },

    methods: {
      setRawData(){
        if(this.rawData && typeof this.rawData === 'object'){

          const education = this.rawData
          this.country = education.country_id
          setTimeout(() => { this.state = education.state_id }, 10)
          this.level = education.level
          this.courses = this.$store.state.domains.courses;
          this.institutions = this.$store.state.domains.institutions;
          
          this.institutions.push({ id: education.institution, name: education.institution })
          setTimeout(() => { this.institution = education.institution }, 10)

          this.courses.push({ id: education.course, name: education.course })
          setTimeout(() => { this.course = education.course }, 10)
          
          this.status = education.status
          this.campus = education.campus
          this.start_date = education.start_date ? this.$moment(education.start_date).format("MM/YYYY") : ''
          this.end_date = education.end_date ? this.$moment(education.end_date).format("MM/YYYY") : ''
          this.period = education.period || '' 
        
        }
      },

      initListeners(){
        this.$EventBus.$on('editingEducation', (education) => {
          let stateEducation = education ? this.$store.state.domains.states.find( st => st.id == education.stateId ) : null;
          let requestData = ''
          let requestDomainParam = ''
          let requestDomainReturn = ''
          this.isLoading = true
          if(education && education.level){
            requestDomainParam+=`level:"${education.level}",`
            requestDomainReturn+=`courses{id, name, level},`
          }
          if(education && education.stateId){
            requestDomainParam+=`state: "${ stateEducation == undefined ? 'Não Definido' : stateEducation['abbr']   }"`
            requestDomainReturn+=`institutions {id, name, state},`
          }
          if(this.$store.state.domains.education_periods.length == 0){
            requestDomainReturn+=`educationPeriods {id, description},`
          }
          if(this.$store.state.domains.education_status.length == 0){
            requestDomainReturn+=`educationStatus {id, description},`
          }
          if(requestDomainParam.length > 0 || requestDomainReturn.length > 0){
            requestData += `domains(${requestDomainParam}){${requestDomainReturn}}`
          }

          if(!education){
            this.reset(false);
          }else{
            this.education_id = education.id
            requestData += `education(id: "${ education.id }", userId: ${ this.$store.state.user.profile.id }) {
              countryId,
              stateId,
              level,
              institutionId,
              institutionName,
              courseId,
              courseName,
              status,
              campus,
              startDate,
              endDate,
              period
            },`;
          }

          this.$store.dispatch("graphql_queries/query", requestData).then( (response) => {
            if(response && response.education){
              const education = response.education
              this.country = education.countryId
              setTimeout(() => { this.state = education.stateId }, 10)
              this.level = education.level
              this.courses = this.$store.state.domains.courses;
              this.institutions = this.$store.state.domains.institutions;
              
              if(education.institutionId == null){
                this.institutions.push({ id: education.institutionName, name: education.institutionName })
                setTimeout(() => { this.institution = education.institutionName }, 10)
              }else{
                setTimeout(() => { this.institution = education.institutionId }, 10)
              }
              if(education.courseId == null){
                this.courses.push({ id: education.courseName, name: education.courseName })
                setTimeout(() => { this.course = education.courseName }, 10)
              }else{
                setTimeout(() => { this.course = education.courseId }, 10)
              }
              this.status = education.status
              this.campus = education.campus
              this.start_date = education.startDate ? this.$moment(education.startDate).format("MM/YYYY") : ''
              this.end_date = education.endDate ? this.$moment(education.endDate).format("MM/YYYY") : ''
              this.period = education.period || ''
            }
            
            this.isLoading = false
          });
        })

        if(this.storeByEventBus){
          this.$EventBus.$on('storeEducationFormInSequence', this.storeForm);
        }
      },

      reset(closeModal = true){
        this.isLoading = false
        this.$v.$reset()
        if(closeModal) this.$emit('closeModal')
        Object.assign(this.$data, this.$options.data.call(this))
        this.initListeners()
        this.start_date = '/'
        this.end_date = '/'
      },

      saveForm(){
        this.$v.$touch();

        if(this.$v.$invalid){
        }else{
          const data = this.$data
          this.$store.dispatch('user/educationCreateUpdate', data).then((response) => {
            if(response.error){
              this.$swal('Uoops', 'Ocorreu um erro ao salvar suas informações', 'error');
            }else{
              this.$store.dispatch("graphql_queries/query", `
                user( id: "${ this.$store.state.user.profile.id }" ){
                  profile{
                    educations {
                      id,
                      institutionName,
                      level,
                      courseName,
                      startDate,
                      endDate,
                      stateId
                    },
                  }
                }
              `).then((updatedData) => {
                this.$swal('Pronto!', 'Formação salva com sucesso', 'success');
                this.reset()
              });
            }
          })
        }
      },

      storeForm(){
        if(this._isDestroyed) return;
        this.$v.$touch();
        if(this.$v.$invalid){
          this.$store.commit('EDUCATIONS_FORMS', {
            _uid: this._uid,
            error: true
          });
        }else{
          this.$store.commit('EDUCATIONS_FORMS', Object.assign(this.$data, {_uid: this._uid}));
        }
      }

    },

  }
</script>

<style lang="scss" scoped></style>